import {createRouter, createWebHistory} from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('./components/HelloWorld.vue'),
  },
  {
    path: '/ok',
    name: 'Ok',
    component: () => import('./components/OK.vue'),
  },
  {
    path: '/install',
    name: 'Install',
    component: () => import('./components/Install.vue'),
  },
  {
    path: '/customersData',
    name: 'CustomersData',
    component: () => import('./components/CustomersData.vue'),
  },
  {
    path: '/customersRedact',
    name: 'CustomersRedact',
    component: () => import('./components/CustomersRedact.vue'),
  },
  {
    path: '/shopRedact',
    name: 'ShopRedact',
    component: () => import('./components/ShopRedact.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
